import { ArrowUp } from "lucide-react";
import { NAV_ITEMS } from "@/data";
import { scrollToSection } from "@/lib/scroll";

export default function Footer() {
    const go = (e, id) => {
        e.preventDefault();
        scrollToSection(id);
    };

    return (
        <footer>
            <div className="wrap">
                <div
                    className="footer-wordmark"
                    data-testid="footer-wordmark"
                    onClick={() => scrollToSection("#top")}
                >
                    SoftwareFairGo<span className="dot">.</span>
                </div>
                <div className="footer-grid">
                    <div className="footer-col footer-tag">
                        Independent technology &amp; software advisory for
                        Australia &amp; New Zealand. A fair go before you sign
                        — not an apology after something breaks.
                    </div>
                    <div className="footer-col">
                        <div className="footer-label">Menu</div>
                        {NAV_ITEMS.map((item) => (
                            <a
                                key={item.id}
                                href={`#${item.id}`}
                                data-testid={`footer-link-${item.id}`}
                                onClick={(e) => go(e, `#${item.id}`)}
                            >
                                {item.label}
                            </a>
                        ))}
                        <a
                            href="#contact"
                            data-testid="footer-link-contact"
                            onClick={(e) => go(e, "#contact")}
                        >
                            Reach us
                        </a>
                    </div>
                    <div className="footer-col">
                        <div className="footer-label">Contact</div>
                        <a
                            href="mailto:enquiries@softwarefairgo.com.au"
                            data-testid="footer-email"
                        >
                            enquiries@softwarefairgo.com.au
                        </a>
                        <span>Government-cleared consultants — Baseline · NV1</span>
                        <span>Servicing Australia &amp; New Zealand</span>
                        <span>Remote by default, on-site by arrangement</span>
                    </div>
                    <div className="footer-col">
                        <div className="footer-label">Admin</div>
                        <a href="/login" data-testid="footer-link-admin-login">
                            Sign in
                        </a>
                        <a
                            href="/admin"
                            data-testid="footer-link-admin-enquiries"
                        >
                            Enquiries inbox
                        </a>
                    </div>
                </div>
                <div className="footer-bottom">
                    <p>
                        © 2026 SoftwareFairGo. Independent technology &amp;
                        software advisory for Australia &amp; New Zealand.
                    </p>
                    <button
                        className="back-to-top"
                        data-testid="footer-back-to-top"
                        onClick={() => scrollToSection("#top")}
                    >
                        Back to top <ArrowUp size={14} strokeWidth={1.5} />
                    </button>
                </div>
            </div>
        </footer>
    );
}
